import type { SkuBenchmark } from '../../data/analytics';
import type { ApiDetail } from '../../features/catalog/model';
import { aggregateBenchmarks } from '../../lib/benchmarks';
import { apiAnswer } from '../../lib/seo/apiAnswer';
import { FaqBand } from '../../components/editorial/FaqBand';
import { m } from '../../paraglide/messages';

/**
 * Bottom-of-page FAQ for a platform page: the answer passage, then the
 * questions the page can answer from its own data, with matching FAQPage
 * JSON-LD.
 *
 * It sits below the endpoint list rather than under the header. The table is
 * what someone landing on /api/<platform> came to read, and a paragraph of
 * prose wedged in front of it pushes the whole page down to say things the
 * table already shows.
 */
export const ApiFaq = ({
  api,
  benchmarks,
}: {
  api: ApiDetail;
  benchmarks: Record<string, SkuBenchmark>;
}) => {
  const skus = api.endpoints.map((e) => e.sku);
  const answer = apiAnswer(api, aggregateBenchmarks(skus, benchmarks));
  if (!answer) return null;

  return (
    <FaqBand
      heading={m.platform_about_heading({ name: api.name })}
      lede={answer.passage}
      questions={answer.questions}
    />
  );
};
